import ServiceItemContainer from "../../booking/containers/ServiceItemContainer";
import { withTranslation } from "react-i18next";
import * as serviceTypes from "../../../data/booking/constants/service_types";
import has from "lodash/has";
import { useTranslation } from "react-i18next";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon, PlusIcon } from "@heroicons/react/20/solid";
import { PlusCircleIcon, PencilSquareIcon, XCircleIcon, NoSymbolIcon } from "@heroicons/react/24/outline";
import cx from "classnames";
import Tooltip from "../../shared/components/Tooltip";

const AddItemButton = ({ serviceType, isActive = false, onClick = null }) => {
    const { t } = useTranslation();
    if (null == onClick) {
        return null;
    }
    let btnWording = "";

    switch (serviceType) {
        case serviceTypes.BAG_TRANSPORT ||
            serviceTypes.BIKE_TRANSPORT ||
            serviceTypes.PEOPLE_TRANSPORT ||
            serviceTypes.REGULAR_SHUTTLE:
            btnWording = t("booking.add_step");
            break;
        case serviceTypes.CAR_TRANSPORT ||
            serviceTypes.CAR_PARKING ||
            serviceTypes.CANCELLATION:
            btnWording = t("booking.add_element");
            break;
        case serviceTypes.CUSTOM:
            btnWording = t("booking.add_product");
            break;
    }

    return (
        <div className="relative mt-6">
            <div className="relative flex justify-center">
                <button
                    type="button"
                    className="
                          m-auto flex items-center justify-center
                          rounded-md border border-transparent bg-orange-600
                          px-8 py-3 text-base
                          font-medium text-white shadow-sm
                          hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
                    onClick={onClick}
                >
                    <PlusIcon className={"mr-1 h-5 w-5 text-white"} />
                    {btnWording}
                </button>
            </div>
        </div>
    );
};

const Service = ({
    service,
    isActive,
    hasEditingItem,
    showActions,
    onAddItem = null,
}) => {
    const {t} = useTranslation();
    return <Disclosure as="section" defaultOpen={true}>
        {({open}) => (
            <>
                <Disclosure.Button className="flex w-full items-center py-4 text-left">
                    <div>
                        <div className="flex items-center gap-3">
                            <div>
                                <p className="text-2xl font-medium text-gray-900">
                                    {serviceTypes.serviceName(service.type)}
                                </p>
                                {service.summary && <p className="ml-1 text-sm text-gray-500">
                                    {(has(service, "route")
                                        ? (service.route?.title ?? service.route?.name) +
                                        " / "
                                        : "") + service.summary}
                                    {(has(service, "items")
                                            ? service.items.map((item, index) =>
                                                item.hour ? " / " + item.hour : "")
                                            : ""
                                    )}
                                </p>}
                            </div>
                        </div>
                    </div>
                    <ChevronUpIcon
                        className={` ${
                            open ? "rotate-180" : ""
                        } ml-auto h-12 w-12 text-orange-500`}
                    />
                </Disclosure.Button>
                <Disclosure.Panel as="div" className={"flow-root"}>
                    <ul role="list" className="-mb-8">
                        {service.items.map((item, index) => (
                            <li key={index} className={cx({
                                "group updated relative": item.updateStatus
                            }, item.updateStatus)}>
                                <ServiceItemContainer
                                    index={index}
                                    nbItems={service.items.length}
                                    key={item.id}
                                    service={service}
                                    item={item}
                                    showActions={showActions}
                                />
                                {item.updateStatus && <span className="absolute -top-2 -right-2">
                                    {item.updateStatus == 'added' && <Tooltip Icon={PlusCircleIcon}
                                                                        iconClassName={"w-8 h-8 bg-blue-400 rounded-full text-slate-50"}
                                                                        content={t('booking.update.added')}/>}
                                    {item.updateStatus == 'edited' && <Tooltip Icon={PencilSquareIcon}
                                                                         iconClassName={"p-1 w-8 h-8 bg-orange-400 rounded-full text-slate-50"}
                                                                         content={t('booking.update.edited')}/>}
                                    {item.updateStatus == 'deleted' && <Tooltip Icon={NoSymbolIcon}
                                                                          iconClassName={"w-8 h-8 bg-red-500 rounded-full text-slate-50"}
                                                                          content={t('booking.update.deleted')}/>}
                                </span>}
                            </li>
                        ))}
                    </ul>
                    <AddItemButton
                        serviceType={service.type}
                        onClick={onAddItem}
                        isActive={isActive && !hasEditingItem}
                    />
                </Disclosure.Panel>
            </>
        )}
    </Disclosure>
};
export default Service;
